<template>
  <section>
    <b-overlay
      :show="branchesIsLoadingOverlay"
      rounded="sm"
      class="my-5"
    >
      <b-container class="position-relative">
        <div class="banner-container d-flex align-items-center justify-content-center">
          <VueSlickCarousel
            :arrows="false"
            :dots="true"
            :key="carouselKey"
            :autoplay="true"
            :speed="5000"
            :autoplaySpeed="5000"
          >
            <template
              v-if="bannerImages.length > 0"
            >
              <div
                v-for="(banner, index) in bannerImages"
                :key="index"
              >
                <template v-if="banner.url_link != ''">
                  <template
                    v-if="
                      banner.url_link.includes('http://') ||
                      banner.url_link.includes('https://')
                    "
                  >
                    <a :href="banner.url_link" target="_blank">
                      <div class="banner-content">
                        <img
                          :src="banner.web_image"
                          alt="Banner"
                          class="mx-auto img-fluid"
                        />
                      </div>
                    </a>
                  </template>
                  <template v-else>
                    <a :href="'http://' + banner.url_link" target="_blank">
                      <div class="banner-content">
                        <img
                          :src="banner.web_image"
                          alt="Banner"
                          class="mx-auto img-fluid"
                        />
                      </div>
                    </a>
                  </template>
                </template>
                <template v-else>
                  <div class="banner-content">
                    <img
                      :src="banner.web_image"
                      alt="Banner"
                      class="mx-auto img-fluid"
                    />
                  </div>
                </template>
              </div>
            </template>
            <template v-else>
              <div
                class="banner-content"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/images/blank-banner.png') + ')',
                }"
              ></div>
            </template>
          </VueSlickCarousel>
        </div>
        <div class="brand-logo-container position-absolute d-flex align-items-center justify-content-center">
          <img :src="brandImage" :alt="displayBrandName" class="img-fluid object-cover">
        </div>
      </b-container>
    </b-overlay>
    <b-container class="py-5">
      <div class="sub-header-text mb-0">{{ displayBrandName }}</div>
      <p class="text-muted">{{ displayBrandCategories }}</p>
      <h5 class="mb-5" v-if="location !== null"> {{ `${filterBranchesByBrand.length} branch${filterBranchesByBrand.length > 1 ? 'es' : ''} near you` }} </h5>
      <b-overlay :show="branchesLoading" rounded="sm">
        <b-row>
          <template v-if="!location">
            <b-container class="enter-location-container my-5 p-5">
                <b-row>
                  <b-col>
                    <h2>Enter your delivery address</h2>
                    <p>This will help us confirm the store's availability.</p>
                  </b-col>
                </b-row>
                <b-row class="justify-content-start mt-3">
                  <b-col md="5">
                    <b-form-group>
                      <div class="form-control d-flex align-items-center justify-content-between py-4 px-1 border-0">
                        <span class="px-2">
                          <img src="@/assets/images/pin-fill.svg" alt="pin-icon">
                        </span>
                        <gmap-autocomplete
                          placeholder="Enter address"
                          @place_changed="setPlace"
                          class="border-0 outline-0 flex-grow-1"
                          :options="{
                            componentRestrictions: { country: 'ph' }
                          }"
                          ref="address"
                          :value="selectedPlace"
                          :disabled="cart !== null && cart.cart_count > 0"
                        >
                        </gmap-autocomplete>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
          </template>
          <template v-else-if="filterBranchesByBrand">
            <template v-if="filterBranchesByBrand.length >= 1">
              <div
                class="col-md-6 col-lg-4"
                v-for="(branch, index) in filterBranchesByBrand"
                v-bind:key="index"
              >
                <div
                  class="store-content-item"
                  @click="
                    goToStore(branch.uuid)
                  "
                >
                  <div
                    v-if="branch.use_brand_logo === false"
                    :class="[
                      'store-content-item-img',
                      {
                        'temp-closed':
                          branch.temporary_closed ||
                          !branch.is_open,
                        'cut-off-time':
                          branch.cut_off_time &&
                          !branch.temporary_closed &&
                          branch.is_open,
                      },
                    ]"
                    :style="{
                      backgroundImage:
                        'url(' + branch.branch_image + ')',
                    }"
                  >
                    <span
                      v-if="
                        branch.cut_off_time &&
                        !branch.temporary_closed &&
                        branch.is_open
                      "
                      class="cut-off-warning-wrapper"
                      >Orders must be placed before
                      {{
                        transformBranchCutOffTime(
                          branch.cut_off_time
                        )
                      }}
                      today</span
                    >
                  </div>
                  <div
                    v-else
                    :class="[
                      'store-content-item-img',
                      {
                        'temp-closed':
                          branch.temporary_closed ||
                          !branch.is_open,
                        'cut-off-time':
                          branch.cut_off_time &&
                          !branch.temporary_closed &&
                          branch.is_open,
                      },
                    ]"
                    :style="{
                      backgroundImage:
                        'url(' + branch.brand_image + ')',
                    }"
                  >
                    <span
                      v-if="
                        branch.cut_off_time &&
                        !branch.temporary_closed &&
                        branch.is_open
                      "
                      class="cut-off-warning-wrapper"
                      >Orders must be placed before
                      {{
                        transformBranchCutOffTime(
                          branch.cut_off_time
                        )
                      }}
                      today</span
                    >
                  </div>
                  <h3
                    :class="[
                      'store-content-item-title',
                      {
                        'temp-closed':
                          branch.temporary_closed ||
                          !branch.is_open,
                      },
                    ]"
                  >
                    {{ branch.brand_name }} ({{ branch.name }})
                  </h3>
                  <p
                    :class="[
                      'store-content-item-subtext text-truncate',
                      {
                        'temp-closed':
                          branch.temporary_closed ||
                          !branch.is_open,
                      },
                    ]"
                  >
                    <template
                      v-for="(category, index) in branch.categories"
                    >
                      <template
                        v-if="branch.categories.length - 1 != index"
                      >
                        {{ category.name + ", " }}
                      </template>
                      <template v-else>
                        {{ category.name }}
                      </template>
                    </template>
                  </p>
                  <div
                    :class="[
                      'store-content-item-desc',
                      {
                        'temp-closed':
                          branch.temporary_closed ||
                          !branch.is_open,
                      },
                    ]"
                  >
                    <template v-if="branch.distance">
                      <span class="distance">{{ branch.distance.toFixed(1) }} km</span>
                      <span class="separator"></span>
                    </template>
                    <template v-if="branch.temporary_closed">
                      <span class="clrRed fw-bold">Temporarily Closed</span>
                    </template>
                    <template v-else>
                      <template v-if="branch.is_open">
                        <span class="clrGreen fw-bold">Open</span>
                      </template>
                      <template v-else>
                        <span class="clrRed fw-bold">Closed</span>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-12">
                <div class="empty-nearby-options text-center">
                  <img
                    src="@/assets/images/empty-nearby-options.png"
                    alt="No nearby options"
                  />
                  <h2 class="mb-4">Sorry!</h2>
                  <p class="mb-0">
                    Your location does not have any nearby options.
                  </p>
                  <p>Let's try another
                    <strong 
                      :class="['cursor-pointer', { 'text-primary': !webDesign || !webDesign.design }]"
                      :style="{ color: webDesign && webDesign.design ? webDesign.design.main_color : null }"
                      @click="triggerSearchLocation"
                    >
                      location search
                    </strong>
                  </p>
                </div>
              </div>
            </template>
          </template>
        </b-row>
      </b-overlay>
    </b-container>
  </section>
  
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      carouselKey: 0,
      selectedPlace: null,
      storedCoordinates: {}
    }
  },
  computed: {
    ...mapState("auth", {
      token: state => state.token,
    }),
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken,
      subdomain: state => state.subdomain
    }),
    ...mapState("branch", {
      coordinates: state => state.coordinates,
      featureBanner: state => state.featureBanner,
      branchesLoading: state => state.loading,
      branchesIsLoadingOverlay: (state) => state.loadingOverlay,
    }),
    ...mapState("estore", {
      webDesign: state => state.webDesign,
      cart: state => state.cart,
      storeDetails: state => state.storeDetails,
    }),
    ...mapState("customer", {
      location: (state) => state.location,
    }),
    ...mapGetters({
      branchesNearby: "branch/branchesNearby",
      homeWebLayout: "design/homeWebLayout",
      isMobile: "isMobile/isMobile"
    }),
    brandUuid: {
      get() {
        return this.$route.params.uuid;
      },
      set(uuid) {
        return uuid;
      }
    },
    isAuthenticated: {
      get() {
        return !!this.token;
      },
      set(token) {
        return token;
      }
    },
    filterBranchesByBrand: {
      get() {
        return this.branchesNearby ? this.branchesNearby.filter(branch => branch.brand_uuid == this.brandUuid) : [];
      },
      set(branches) {
        return branches;
      }
    },
    bannerImages: {
      get() {
        return this.featureBanner && this.featureBanner.feature_banner.length > 0
          ? this.featureBanner && this.featureBanner.feature_banner
          : [];
      },
      set(banner) {
        return banner;
      }
    },
    brandImage: {
      get() {
        return this.homeWebLayout.our_brands && this.homeWebLayout.our_brands.length > 0
          ? JSON.parse(this.homeWebLayout.our_brands).find(brand => brand.uuid === this.brandUuid).logo
          : null
      },
      set(image) {
        return image;
      }
    },
    displayBrandName: {
      get() {
        return this.filterBranchesByBrand && this.filterBranchesByBrand.length > 0
          ? this.filterBranchesByBrand[0].brand_name
          : null;
      },
      set(name) {
        return name;
      }
    },
    displayBrandCategories: {
      get() {
        return this.filterBranchesByBrand && this.filterBranchesByBrand.length > 0
          ? this.filterBranchesByBrand[0].categories.map(category => category.name).join(", ")
          : null;
      },
      set(categories) {
        return categories;
      }
    }
  },
  created() {
    const request = {
      header: {
        "X-Merchant-Token": this.customerPortalToken
      }
    };
    if (this.coordinates) {
      request["payload"] =  {
        latitude: this.coordinates.lat,
        longitude: this.coordinates.long
      };
      if (this.isAuthenticated) {
        request.header["Authorization"] = this.token;
        this.getBranchesNearby(request);
      } else this.getBranchesNearbyPublic(request);
    }
    this.getHomeWebLayout({ header: request.header });
    this.getFeaturedBannerList();
    window.scrollTo(0, 0);
  },
  methods: {
    ...mapActions({
      getBranchesNearbyPublic: "branch/getBranchesNearbyPublic",
      getBranchesNearby: "branch/getBranchesNearby",
      getHomeWebLayout: "design/getHomeWebLayout"
    }),
    goToStore(branch_uuid) {
      if (this.storeDetails !== null) {
        if (!this.storeDetails.allow_purchase_multiple) {
          if (this.cart) {
            if (
              this.cart.cart_count > 0 &&
              this.cart.list[0].branch_uuid != branch_uuid
            ) {
              this.$refs.changeBrandBranch.show();
            } else {
              this.$router.push({ name: "Store", params: { subdomain: this.subdomain, id: `${branch_uuid}&${this.brandUuid}` } });
            }
          } else {
            this.$router.push({ name: "Store", params: { subdomain: this.subdomain, id: `${branch_uuid}&${this.brandUuid}` } });
          }
        } else {
          this.$router.push({ name: "Store", params: { subdomain: this.subdomain, id: `${branch_uuid}&${this.brandUuid}` } });
        }
      } else {
        this.$router.push({ name: "Store", params: { subdomain: this.subdomain, id: `${branch_uuid}&${this.brandUuid}` } });
      }
    },
    transformBranchCutOffTime(cutOff) {
      const splitTime = {
        hour: cutOff.split(":")[0],
        minutes: cutOff.split(":").pop(),
      };
      return this.$moment()
        .set({ hour: splitTime.hour, minute: splitTime.minutes, second: 0 })
        .format("h:mma");
    },
    triggerSearchLocation() {
      this.$root.$emit("openMap");
    },
    async getFeaturedBannerList() {
      let request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: null,
      };

      await this.$store.dispatch("branch/getFeaturedBannerList", request);
    },
    setPlace(place) {
      this.selectedPlace = place.formatted_address;
      this.storedCoordinates = {
        lat: place.geometry.location.lat(),
        long: place.geometry.location.lng(),
        distance: 8
      };
      this.$nextTick(() => {
        this.searchWhatsNearby();
      });
    },
    searchWhatsNearby() {
      this.$store.commit("branch/SET_COORDINATES", this.storedCoordinates);
      this.$store.commit("customer/SET_LOCATION", this.selectedPlace);
      this.$root.$emit("inPageMapSetSelectedPlace", this.selectedPlace);
    }
  },
  watch: {
    coordinates(coordinates) {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        payload: {
          latitude: coordinates.lat,
          longitude: coordinates.long
        }
      };
      if (this.isAuthenticated) {
        request.header["Authorization"] = this.token;
        this.getBranchesNearby(request);
      } else this.getBranchesNearbyPublic(request);
    },
    filterBranchesByBrand() {
      this.carouselKey = this.carouselKey += 1;
    }
  }
}
</script>

<style lang="scss" scoped>
.temp-closed,
.cut-off-time {
  &.store-content-item-img {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    &:not(.cut-off-time)::before {
      content: "Store Closed";
      background-color: #49545c;
      color: white;
      font-size: 14px;
      padding: 7px 14px;
      border-radius: 5px;
      z-index: 1;
      margin-bottom: 25px;
    }
    &:not(.cut-off-time)::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #c4c4c4;
      opacity: 0.5;
    }
    .cut-off-warning-wrapper {
      background-color: #49545c;
      color: white;
      font-size: 14px;
      padding: 7px 14px;
      border-radius: 5px;
      z-index: 1;
      margin-bottom: 25px;
      max-width: 200px;
      text-align: center;
    }
  }
  &.store-content-item-title,
  &.store-content-item-subtext,
  &.store-content-item-desc {
    opacity: 0.5;
  }
}
.banner-container {
  border-radius: 30px;
  overflow: hidden;
  height: 320px;
}
.brand-logo-container {
  left: 43px;
  bottom: -35px;
  width: 120px;
  height: 120px;
  border-radius: 25px;
  box-shadow: 0px 4px 40px 10px rgba(131, 134, 146, 0.15);
  background: #fff;
  overflow: hidden;
  & > img {
    max-width: 86px;
  }
}
.outline-0 {
  outline: 0;
}
.enter-location-container {
  background: #F7F8F9;
  border-radius: 15px;
  h2 {
    font-size: 26px;
    color: #2F3941;
    @extend .mainFontBold;
  }
  p {
    font-size: 14px;
    color: #68737D;
  }
  .form-control {
    .pac-target-input {
      font-size: 16px;
      color: #2F3941;
    }
  }
}
</style>
